
import { useTranslation } from 'next-i18next';
import styles from './style.module.scss';
import Image from 'next/image';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';

type LocationUnavailableProps = {
  /** The path to the image to be used as the graphic for the location unavailable component. Defaults to `/next/assets/images/listing-page/location-unavailable.svg`. */
  src?: string;
  /** The alt text for the image. Defaults to `Location unavailable` in the current locale. */
  alt?: string;
  /** The message to display. Defaults to `Location info is unavailable for now, but we'll update it once we have it.` in the current locale. */
  message?: string;
};

/**
 * A component that can be used to indicate that the location of a listing is unavailable.
 */
export default function LocationUnavailable(props: LocationUnavailableProps) {
  const { t } = useTranslation(Namespaces.COMMON);
  const {
    src = '/next/assets/images/listing-page/location-unavailable.svg',
    alt = t(LOCALE_COMMON_PATHS.ADDRESS_LOCATION_UNAVAILABLE_ALT),
    message = t(LOCALE_COMMON_PATHS.ADDRESS_LOCATION_UNAVAILABLE),
  } = props;
  return (
    <div className={styles.component}>
      <div className={styles.content}>
        <Image src={src} alt={alt} fill={true} unoptimized={src.endsWith('.svg')} />
        <div className={styles.message}>{message}</div>
      </div>
    </div>
  );
}
